import { FC } from 'react';

import styled from '@emotion/styled';

import { IcoCalendar, IcoRightCircled } from '@britishcouncil/react-solas';

export const SimpleSystemTime: FC<{
  systemDate?: string;
  onOpen: () => void;
}> = ({ systemDate, onOpen }) => {
  return (
    <FlexBox>
      <IcoCalendar /> {systemDate ?? '...'}
      <IcoRightCircled onClick={() => onOpen()} />
    </FlexBox>
  );
};

const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
